export default __webpack_public_path__ + "20d3e6ef96e5a405f30429d6d92b83e2.png";